import React from 'react'
import { Modal, Card, Grid, Divider, Icon, Image, Tab, Menu, Label, Button } from 'semantic-ui-react'
import CommonTable from '../../../../drive/Table/TableLayout';

import Labels from '../../../../common/Labels'
import momentDateAndTime from '../../../../../helpers/momentDateAndTime';
import convertIcon from '../../../../../helpers/convert-Icon';
import playbookJson from './PlaybookUsage.json'
import initiativeJson from './InitiativeUsage.json'
import defaultImage from '../../../../../images/logo/logo-128.png'
class AssignmentModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {

            activeIndex: 0,
            _limit: 10,
            _sort: "createdAt"
        }
    }

    close = () => {
        this.props.openUsageContentModal(false);
    }

    handleTabChange = (e, data) => {
        this.setState({ activeIndex: data.activeIndex })

    }

    openURL = (url) => {
        let redirectUrl = url.indexOf('://') === -1 ? 'http://' + url : url;
        window.open(redirectUrl, '_blank');
    }

    render() {

        const { activeIndex } = this.state;
        let setData = [];
        let setHeader = playbookJson

        if (activeIndex === 0) {
            setData = this.props.selectedContent && this.props.selectedContent.playbookActivitiesRef && this.props.selectedContent.playbookActivitiesRef.length !== 0 ?
                this.props.selectedContent.playbookActivitiesRef.map((m, i) => {
                    if (m.playbookId) {
                        if (m.playbookId.status === 0) {
                            m.updatedStatus = 'In Design'
                        } else if (m.playbookId.status === 1) {
                            m.updatedStatus = 'In Review';
                        } else if (m.playbookId.status === 2) {
                            m.updatedStatus = 'Approved';
                        } else if (m.playbookId.status === 4) {
                            m.updatedStatus = 'Published';
                        } else if (m.playbookId.status === 5) {
                            m.updatedStatus = 'Inactive';
                        }
                        else {
                            m.updatedStatus = m.playbookId.status
                        }

                        m.name = m.playbookId.name
                        m.firstName = m.playbookId && m.playbookId.createdBy ? m.playbookId.createdBy.firstName : '';
                        m.lastName = m.playbookId && m.playbookId.createdBy ? m.playbookId.createdBy.lastName : '';
                        m.profilePic = m.playbookId && m.playbookId.createdBy ? m.playbookId.createdBy.profilePic : '';
                        m.activityName = m.activityId.name;
                        m.picture = m.playbookId.picture;
                        m.createdAt = m.playbookId.createdAt;
                        m.creator = m.playbookId && m.playbookId.createdBy ? m.playbookId.createdBy.firstName + '' + m.playbookId.createdBy.lastName : '';

                        return m
                    } else {
                        return m
                    }
                }) : []
            setHeader = playbookJson
        }

        if (activeIndex === 1) {
            setData = this.props.selectedContent && this.props.selectedContent.initiativeActivitiesRef && this.props.selectedContent.initiativeActivitiesRef.length !== 0 ?
                this.props.selectedContent.initiativeActivitiesRef.map((m, i) => {
                    if (m.initiativeId) {
                        if (m.initiativeId.status === 0) {
                            m.updatedStatus = 'In Design'
                        } else if (m.initiativeId.status === 1) {
                            m.updatedStatus = 'Active';
                        } else if (m.initiativeId.status === 2) {
                            m.updatedStatus = 'Active';
                        } else if (m.initiativeId.status === 3) {
                            m.updatedStatus = 'Closed';
                        } else if (m.initiativeId.status === 4) {
                            m.updatedStatus = 'Active';
                        } else if (m.initiativeId.status === 5) {
                            m.updatedStatus = 'Cancelled';
                        } else {
                            m.updatedStatus = m.initiativeId.status
                        }

                        m.name = m.initiativeId.name
                        m.firstName = m.initiativeId && m.initiativeId.createdBy ? m.initiativeId.createdBy.firstName : '';
                        m.lastName = m.initiativeId && m.initiativeId.createdBy ? m.initiativeId.createdBy.lastName : '';
                        m.profilePic = m.initiativeId && m.initiativeId.createdBy ? m.initiativeId.createdBy.profilePic : '';
                        m.activityName = m.activityId.name;
                        m.picture = m.initiativeId.picture;
                        m.createdAt = m.initiativeId.createdAt;
                        m.creator = m.initiativeId && m.initiativeId.createdBy ? m.initiativeId.createdBy.firstName + '' + m.initiativeId.createdBy.lastName : '';
                        return m
                    } else {
                        return m
                    }

                }) : []

            setHeader = initiativeJson
        }

        let ContentInfo = <Card className=" w_100 " style={{ margin: "0 0 20px 0" }}>
            <Card.Content className="pad_0">
                <Grid  >
                    <Grid.Row style={{ padding: "10px 0 5px 0" }}>
                        <Grid.Column width={4} >
                            <Labels
                                name="Owner"
                                text={<span>
                                    <Image avatar className="w_24 h_24 float-left" src={this.props.selectedContent.createdBy.profilePic} />
                                    <b style={{ padding: "3px 0 0 0", display: "block" }}>
                                        {this.props.selectedContent.createdBy.firstName}&nbsp;
                                        {this.props.selectedContent.createdBy.lastName}
                                    </b>
                                </span>}
                            />
                        </Grid.Column>
                        <Grid.Column width={12}>
                            <Labels
                                name="Name"
                                text={this.props.selectedContent.name}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row style={{ padding: "10px 0 5px 0" }}>
                        <Grid.Column width={4}>
                            <Labels
                                name="Knowledge bank"
                                text={<span>
                                    <Image avatar className="w_24 h_24 float-left" src={
                                        this.props.selectedContent.baseCategory.image ?
                                            this.props.selectedContent.baseCategory.image : defaultImage
                                    } />
                                    <b style={{ padding: "3px 0 0 0", display: "block" }}>
                                        {this.props.selectedContent.baseCategory.name}
                                    </b>
                                </span>}
                            />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Labels
                                name="Category"
                                text={<span>
                                    {this.props.selectedContent.category.name}
                                </span>
                                }
                            />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Labels
                                name="Sub Category"
                                text={this.props.selectedContent.subCategory.name}
                            />
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Labels
                                name="Published on"
                                text={momentDateAndTime(this.props.selectedContent.createdAt)}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Card.Content>
        </Card>



        const panes = [
            {
                menuItem: <Menu.Item key='Playbook'> Playbook Activities<Label>{this.props.selectedContent.playbookActivitiesRef.length}</Label></Menu.Item>,
                render: () => table
            },
            {
                menuItem: <Menu.Item key='Initiative'> Initiative Activities <Label>{this.props.selectedContent.initiativeActivitiesRef.length}</Label></Menu.Item>,
                render: () => table
            }
        ]

        let table = <CommonTable
            tableHeader={setHeader}
            listData={setData}
            searchable={false}
            limit={this.state._limit}
            sort={this.state._sort}
            selection={false}
            totalCount={setData && setData.length}
            activeIndex={this.state.activeIndex}
            filterHeader={true}
        />
        return (
            <Modal
                className="basicModal"
                open={this.props.open}
                closeOnEscape={true}
                closeOnDimmerClick={false}
                size="large"
                closeIcon
                onClose={this.close}
            >
                <Modal.Header>
                    Content Usage
                </Modal.Header>
                <Divider />
                <Modal.Content className="pad_20" scrolling
                    style={{ minHeight: "450px" }}>
                    {ContentInfo}
                    <Tab className="two-block" style={{ boxShadow: " 0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5", borderRadius: "4px" }}
                        menu={{ secondary: true, pointing: true, className: "mar_0" }}
                        panes={panes}
                        onTabChange={this.handleTabChange} />
                </Modal.Content>
                <Modal.Actions className="actionInFormcy">
                    <Button
                        id='viewContent'
                        className="button-info"
                        onClick={e => this.openURL(this.props.selectedContent.contentpath)}
                        type="button"> <Icon name={convertIcon(this.props.selectedContent.type)} /> {this.props.selectedContent.type} </Button>
                    <Button
                        id='cancelBtn'
                        className="button-submit"
                        onClick={this.close}
                        type="button"> Got it </Button>


                </Modal.Actions>
            </Modal >

        )
    }
}
export default AssignmentModal;